export function formatContactFullName(
  firstName?: string | null,
  lastName?: string | null
): string {
  const last = lastName ?? '';
  const first = firstName ?? '';
  return `${last}${last && first ? ', ' : ''}${first}`;
}
